/**
 * Los roles de equipo, en UN SOLO SITIO.
 *
 * 🚨 Esto nace de un fallo real: al estrenar el perfil de coanfitrión, el panel lo
 * mandaba a «crear tu primer alojamiento» en cuanto se movía de pantalla. La causa era
 * que la lista de «quién ve todas las propiedades» estaba escrita a mano en TRES
 * ficheros, y en los tres ponía `["anfitrion", "gestor"]`. El coanfitrión no estaba, así
 * que se le filtraba la lista de propiedades por sus `assigned_property_ids` —que están
 * vacíos, porque es un perfil de acceso total y no se le asigna ninguna— y se quedaba sin
 * ni una. Con cero propiedades, el panel entiende que es una cuenta nueva.
 *
 * Son espejo del servidor:
 *   ACCESO_TOTAL    ↔ TeamPermissions::isFullAccessRole()
 *   SIN_IMPORTES    ↔ TeamPermissions::ROLES_SIN_IMPORTES
 *
 * Al añadir un rol nuevo hay que tocar los dos lados, pero al menos aquí es un sitio y
 * no tres.
 */

/** Ven TODAS las propiedades del anfitrión, sin asignación explícita. */
export const ROLES_ACCESO_TOTAL = ["anfitrion", "gestor", "coanfitrion"];

/** No ven ningún importe. */
export const ROLES_SIN_IMPORTES = ["coanfitrion"];

/**
 * ¿Este usuario ve todas las propiedades?
 * El anfitrión titular (sin subUser) siempre.
 */
export function tieneAccesoTotal(subUser) {
  if (!subUser) return true;
  return ROLES_ACCESO_TOTAL.includes(subUser.sub_role);
}

/** ¿Hay que esconderle los importes? El anfitrión titular ve su dinero. */
export function ocultaImportes(subUser) {
  if (!subUser) return false;
  return ROLES_SIN_IMPORTES.includes(subUser.sub_role);
}
